import styled from 'styled-components';

export const FloatingActions = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	bottom: 32px;
	display: flex;
	justify-content: center;
	z-index: 100;
	pointer-events: none;
`;

export const ActionsBar = styled.div`
	background: #fff;
	border-radius: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	display: flex;
	gap: 16px;
	align-items: center;
	padding: 8px 24px;
	pointer-events: all;
`;
